import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { LendWithdrawDialogContentContainer } from './LendWithdrawDialogContentContainer'

export interface LendWithdrawDialogProps extends CommonDialogProps {
  walletOverview: MyWalletProps
}

function LendWithdrawDialog({ open, setOpen, walletOverview }: LendWithdrawDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <LendWithdrawDialogContentContainer walletOverview={walletOverview} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const lendWithdrawDialogConfig: DialogConfig<LendWithdrawDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: LendWithdrawDialog,
}
